import { ChangeEvent, useEffect, useRef } from 'react';
import { FieldProps } from 'formik';

import { convertToPlace } from 'utils/google-maps/common';

export default function WorkField({ form, ...props }: FieldProps) {
  const autoCompleteRef = useRef<google.maps.places.Autocomplete | null>(null);
  const workFieldRef = useRef<HTMLInputElement | null>(null);

  function initAutofill() {
    const workField = workFieldRef.current;

    if (typeof window !== 'undefined' && window.google && workField) {
    
      autoCompleteRef.current = new google.maps.places.Autocomplete(workField);
      if (autoCompleteRef.current) {
        autoCompleteRef.current.setFields(['address_components', 'formatted_address', 'geometry', 'name', 'type', 'place_id', 'formatted_phone_number', 'international_phone_number', 'website']);
    
        autoCompleteRef.current.addListener('place_changed', () => {
          if (autoCompleteRef.current?.getPlace()) {
            const placeResult = autoCompleteRef.current.getPlace();
            const updatedValues = convertToPlace(placeResult);

            Object.keys(updatedValues).forEach(key => {
              form.setFieldValue(key, updatedValues[key]);
            });

            workField.value = updatedValues.name || '';
            form.setFieldValue('company', updatedValues.name);
          }
        });
      }
      
      workField.addEventListener('blur', handleBlur);
    }
  }

  function handleBlur(event: FocusEvent) {
    const target = event.target as HTMLInputElement;
    if (autoCompleteRef.current?.getPlace()) {
      const updatedValues = convertToPlace(autoCompleteRef.current.getPlace());
      // On a blur event if the comapny name of the input does not match company name from the autocomplete, reset the address fields. 
      // This does not happen on the place_changed event listener if the company is not in the autocomplete list.
      if (target.value.trim().toLowerCase() != updatedValues.name?.trim().toLocaleLowerCase()) {
        [ 
          'address', 
          'street_name', 
          'street_number', 
          'locality', 
          'sub_locality',
          'region', 
          'postal_code', 
          'country',
          'latitude', 
          'longitude', 
          'place_type',
          'place_id', 
          'formatted_phone_number',
          'international_phone_number', 
          'website',
        ].forEach(key => form.setFieldValue(key, ''));
      }
    }
  }

  function handleChange(e: ChangeEvent<HTMLInputElement>) {
    form.setFieldValue('company', e.target.value);
  }

  useEffect(() => {
    const scriptExists = document.getElementById('googlePlaces');
    if (!scriptExists) {
        
      const placesScript = document.createElement('script');
        
      placesScript.onload = () => {
        initAutofill();
      };
        
      placesScript.id = 'googlePlaces';
      placesScript.type = 'text/javascript';
      placesScript.src = '//maps.google.com/maps/api/js?key=AIzaSyDnIy4H6lL24aD7VnYxc1hKYYJM1r63Qlo&libraries=places&types=establishment';
      document.body.appendChild(placesScript);
        
    } else {
      initAutofill();
    }
          
    return () => {
      if (workFieldRef.current) {
        workFieldRef.current.removeEventListener('blur', handleBlur);
      }
    };     
  }, []);

  return (
    <input ref={ workFieldRef } type="text" id="company" onChange={ handleChange } { ...props } />
  );
}
